module.exports = __webpack_public_path__ + "static/media/printer-orange.145af4a7.svg";